import { useMutation } from '@apollo/client';
import { Pricing } from '../../shared/types';
import { CITRIN_UPDATE_PRICING, UpdatePricingRequest, UpdatePricingResponse } from '..';

type UpdateMutationFunction = (request: Pricing) => Promise<Pricing>;
export const useUpdatePricingMutation = (): { mutation: UpdateMutationFunction; loading: boolean } => {
    const [mutation, { loading }] = useMutation<UpdatePricingResponse, UpdatePricingRequest>(CITRIN_UPDATE_PRICING);
    const promiseMutation = async (request) => {
        const result = await mutation({
            variables: { request },
        });
        return result.data.CITRIN_MGT_updatePricing;
    };

    return {
        mutation: promiseMutation,
        loading,
    };
};
